import React from 'react';
import {
  CreateButton,
  FilterLiveSearch,
  TopToolbar,
  usePermissions,
  useTranslate
} from 'react-admin';
import { PrivilegeType } from '../../../core/models/privileges/privilegeType';
import { some } from '../../../core/utils/collection-utils';

export const EfficiencyTestsListActions = () => {
  const { permissions } = usePermissions();
  const t = useTranslate();
  return (
    <TopToolbar>
      <FilterLiveSearch
        source="searchText"
        placeholder={t('resources.efficiency-tests.filters.search')}
      />
      {some([PrivilegeType.MANAGE_EFFICIENCY_TEST], permissions) && (
        <CreateButton resource="/efficiency-tests" />
      )}
    </TopToolbar>
  );
};
